import { createSelector } from 'reselect';

import { scheduledTransactionsSelectors } from 'app-components/flux/scheduled-transactions';

import { REDUCER_KEY } from './billerAccountsReducer';

export const getBillerAccountsStore = (state) => state[REDUCER_KEY];

export const getBillerAccountsById = (state) => getBillerAccountsStore(state).resourcesById;
export const getLoadPending = (state) => getBillerAccountsStore(state).loadPending;
export const getLastSyncDate = (state) => getBillerAccountsStore(state).lastSyncDate;
export const getIsLoading = (state) => getBillerAccountsStore(state).isLoading;

export const getBillerAccountForId = (state, id) => getBillerAccountsById(state).get(id);

export const getBillerAccountsForLoginId = createSelector(
  getBillerAccountsById,
  (_, id) => id,
  (billerAccounts, id) => billerAccounts.filter((account) => account.billerLoginID === id),
);

export const getUnconnectedAccounts = createSelector(
  getBillerAccountsForLoginId,
  scheduledTransactionsSelectors.getScheduledTransactions,
  (currentAccounts, scheduledTxns) =>
    currentAccounts.filter((account) => !scheduledTxns.find((model) => model.billPresentmentAccountId === account.id)),
);

export const getConnectedModels = createSelector(
  scheduledTransactionsSelectors.getScheduledTransactions,
  (scheduledTxns) =>
    scheduledTxns?.filter(
      (model) =>
        (model.billPresentmentBillerId && model.billPresentmentBillerId.length) ||
        (model.billPresentmentAccountId && model.billPresentmentAccountId.length),
    ),
);
